<template>
    <div>
        <v-switch v-model="userModeEnabled" label="Enable user"></v-switch>
        <v-switch v-model="expertModeEnabled" label="Expert mode enabled"></v-switch>
    </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";

export default {
  name: "expert-options",
  computed: {
    ...mapGetters(["isAdmin", "isExpert"]),
    userModeEnabled: {
      set(userModeEnabled) {
        this.enableUserMode(userModeEnabled);
      },
      get() {
        return !this.isAdmin;
      }
    },
    expertModeEnabled: {
      set(expertModeEnabled) {
        this.enableExpertMode(expertModeEnabled);
      },
      get() {
        return this.isExpert;
      }
    }
  },
  methods: {
    ...mapActions(["enableUserMode", "enableExpertMode"])
  }
};
</script>

